import { NEW_PUBLISH_OPTIONS } from 'EmailEditorUI/constants/publishOptions';
import { TIMEZONE_RADIO_TYPES } from 'EmailEditorUI/constants/timezoneRadioTypes';
import { DEFAULT_HOURS } from 'EmailEditorUI/constants/sendTimeOptimization';
import { createSelector } from 'reselect';
import { SendTimeOptimizationErrorKeys } from 'EmailEditorUI/constants/SendTimeOptimizationConstants';
import { getPublishDate } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getNumToSendTo
// @ts-expect-error no declarations found for module
} from 'EmailEditorUI/redux/selectors/RecipientsSelectors';
import { getEmailThrottleSendSpeed
// @ts-expect-error module not yet migrated
} from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { SEND_TIME_UNIT } from 'EmailEditorUI/constants/SendSpeedConstants';
export const getTimezoneRadio = state => {
  var _state$schedule$selec, _state$schedule;
  return (_state$schedule$selec = (_state$schedule = state.schedule) === null || _state$schedule === void 0 ? void 0 : _state$schedule.selectedTimezoneRadio) !== null && _state$schedule$selec !== void 0 ? _state$schedule$selec : TIMEZONE_RADIO_TYPES.portal;
};
export const getPreviousTimezoneRadio = state => {
  var _state$schedule$previ, _state$schedule2;
  return (_state$schedule$previ = (_state$schedule2 = state.schedule) === null || _state$schedule2 === void 0 ? void 0 : _state$schedule2.previousTimezoneRadio) !== null && _state$schedule$previ !== void 0 ? _state$schedule$previ : null;
};
export const getConversionAlertShown = state => {
  var _state$schedule$conve, _state$schedule3;
  return (_state$schedule$conve = (_state$schedule3 = state.schedule) === null || _state$schedule3 === void 0 ? void 0 : _state$schedule3.conversionAlertShown) !== null && _state$schedule$conve !== void 0 ? _state$schedule$conve : false;
};
export const getStoExistedDuringTimezoneSwitch = state => {
  var _state$schedule$stoEx, _state$schedule4;
  return (_state$schedule$stoEx = (_state$schedule4 = state.schedule) === null || _state$schedule4 === void 0 ? void 0 : _state$schedule4.stoExistedDuringTimezoneSwitch) !== null && _state$schedule$stoEx !== void 0 ? _state$schedule$stoEx : false;
};
export const getStagedDate = state => {
  var _state$schedule$stage, _state$schedule5;
  return (_state$schedule$stage = (_state$schedule5 = state.schedule) === null || _state$schedule5 === void 0 ? void 0 : _state$schedule5.stagedDate) !== null && _state$schedule$stage !== void 0 ? _state$schedule$stage : null;
};
export const getStagedTime = state => {
  var _state$schedule$stage2, _state$schedule6;
  return (_state$schedule$stage2 = (_state$schedule6 = state.schedule) === null || _state$schedule6 === void 0 ? void 0 : _state$schedule6.stagedTime) !== null && _state$schedule$stage2 !== void 0 ? _state$schedule$stage2 : null;
};
export const getPublishingOption = state => {
  var _state$schedule$publi, _state$schedule7;
  return (_state$schedule$publi = (_state$schedule7 = state.schedule) === null || _state$schedule7 === void 0 ? void 0 : _state$schedule7.publishOption) !== null && _state$schedule$publi !== void 0 ? _state$schedule$publi : NEW_PUBLISH_OPTIONS.PUBLISH_NOW;
};
export const getSTOSimpleTimeFrame = state => {
  var _state$schedule$STOSi, _state$schedule8;
  return (_state$schedule$STOSi = (_state$schedule8 = state.schedule) === null || _state$schedule8 === void 0 ? void 0 : _state$schedule8.STOSimpleTimeFrame) !== null && _state$schedule$STOSi !== void 0 ? _state$schedule$STOSi : DEFAULT_HOURS;
};
export const getSTOTimeFrameType = state => {
  var _state$schedule$STOTi, _state$schedule9;
  return (_state$schedule$STOTi = (_state$schedule9 = state.schedule) === null || _state$schedule9 === void 0 ? void 0 : _state$schedule9.STOTimeFrameType) !== null && _state$schedule$STOTi !== void 0 ? _state$schedule$STOTi : 'simple';
};
export const getEarliestDate = state => {
  var _state$schedule$earli, _state$schedule10;
  return (_state$schedule$earli = (_state$schedule10 = state.schedule) === null || _state$schedule10 === void 0 ? void 0 : _state$schedule10.earliestDate) !== null && _state$schedule$earli !== void 0 ? _state$schedule$earli : null;
};
export const getEarliestTime = state => {
  var _state$schedule$earli2, _state$schedule11;
  return (_state$schedule$earli2 = (_state$schedule11 = state.schedule) === null || _state$schedule11 === void 0 ? void 0 : _state$schedule11.earliestTime) !== null && _state$schedule$earli2 !== void 0 ? _state$schedule$earli2 : null;
};
export const getLatestDate = state => {
  var _state$schedule$lates, _state$schedule12;
  return (_state$schedule$lates = (_state$schedule12 = state.schedule) === null || _state$schedule12 === void 0 ? void 0 : _state$schedule12.latestDate) !== null && _state$schedule$lates !== void 0 ? _state$schedule$lates : null;
};
export const getLatestTime = state => {
  var _state$schedule$lates2, _state$schedule13;
  return (_state$schedule$lates2 = (_state$schedule13 = state.schedule) === null || _state$schedule13 === void 0 ? void 0 : _state$schedule13.latestTime) !== null && _state$schedule$lates2 !== void 0 ? _state$schedule$lates2 : null;
};
export const getEarliestDateTime = state => {
  var _state$schedule$earli3, _state$schedule14;
  return (_state$schedule$earli3 = (_state$schedule14 = state.schedule) === null || _state$schedule14 === void 0 ? void 0 : _state$schedule14.earliestDateTime) !== null && _state$schedule$earli3 !== void 0 ? _state$schedule$earli3 : null;
};
export const getLatestDateTime = state => {
  var _state$schedule$lates3, _state$schedule15;
  return (_state$schedule$lates3 = (_state$schedule15 = state.schedule) === null || _state$schedule15 === void 0 ? void 0 : _state$schedule15.latestDateTime) !== null && _state$schedule$lates3 !== void 0 ? _state$schedule$lates3 : null;
};
export const getCampaignSTOWasUsed = state => {
  var _state$schedule$campa, _state$schedule16;
  const campaignSTOWasUsed = (_state$schedule$campa = (_state$schedule16 = state.schedule) === null || _state$schedule16 === void 0 ? void 0 : _state$schedule16.campaignSTOWasUsed) !== null && _state$schedule$campa !== void 0 ? _state$schedule$campa : false;
  const publishingOption = getPublishingOption(state);
  return campaignSTOWasUsed && publishingOption === NEW_PUBLISH_OPTIONS.SCHEDULE;
};
export const getConversionAlert = state => {
  const stoWasUsed = getCampaignSTOWasUsed(state);
  const selectedTimezoneRadio = getTimezoneRadio(state);
  const previousTimezoneRadio = getPreviousTimezoneRadio(state);
  const conversionAlertShown = getConversionAlertShown(state);
  const stoExistedDuringTimezoneSwitch = getStoExistedDuringTimezoneSwitch(state);

  // Don't show alert if already shown
  if (conversionAlertShown) {
    return null;
  }

  // Don't show alert if STO wasn't used
  if (!stoWasUsed) {
    return null;
  }

  // Only show conversion alert if STO existed DURING the timezone switch
  if (!stoExistedDuringTimezoneSwitch) {
    return null;
  }

  // Check for conversion from portal to user timezone
  if (selectedTimezoneRadio === TIMEZONE_RADIO_TYPES.userObject && previousTimezoneRadio === TIMEZONE_RADIO_TYPES.portal) {
    return 'toUser';
  }

  // Check for conversion from user to portal timezone
  if (selectedTimezoneRadio === TIMEZONE_RADIO_TYPES.portal && previousTimezoneRadio === TIMEZONE_RADIO_TYPES.userObject) {
    return 'toPortal';
  }
  return null;
};

/**
 * Get Contact STO validation errors/warnings from backend validation API.
 * This is the new single source of truth for STO validation, replacing frontend logic.
 * Works for both custom and simple time frame types.
 */
export const getContactSTOAlertStatus = createSelector([state => state.emailValidation, getPublishingOption], (validationResult, publishingOption) => {
  // Only check for Contact STO
  if (publishingOption !== NEW_PUBLISH_OPTIONS.CONTACT_STO) {
    return null;
  }

  // No validation result yet
  if (!(validationResult !== null && validationResult !== void 0 && validationResult.errors)) {
    return null;
  }

  // Find any STO-related errors from backend validation
  const stoError = validationResult.errors.find(error => Object.values(SendTimeOptimizationErrorKeys).includes(error.errorKey));
  if (stoError) {
    return stoError.errorKey;
  }
  return null;
});
export const getContactSTOPublishDate = createSelector([getPublishingOption, getSTOTimeFrameType, getEarliestDateTime], (publishingOption, stoTimeFrameType, earliestDateTime) => {
  if (publishingOption === NEW_PUBLISH_OPTIONS.CONTACT_STO) {
    if (stoTimeFrameType === 'simple') {
      return Date.now();
    } else if (stoTimeFrameType === 'custom' && earliestDateTime) {
      // If earliestDateTime is in the past, use current time
      return earliestDateTime < Date.now() ? Date.now() : earliestDateTime;
    }
  }
  return null;
});

/**
 * Core function to generate STO data with configurable field naming conventions
 */
const generateSTOData = (state, useSnakeCase = false) => {
  var _state$contentModel;
  // Only include STO data for BATCH_EMAIL type as it's the main email type that supports STO features
  // Other email types (single send API, automated, etc.) don't use STO
  const emailType = (_state$contentModel = state.contentModel) === null || _state$contentModel === void 0 ? void 0 : _state$contentModel.emailType;
  if (emailType !== 'BATCH_EMAIL') {
    return {
      send_time_optimization: null
    };
  }
  const campaignSTOWasUsed = getCampaignSTOWasUsed(state);
  const publishingOption = getPublishingOption(state);
  const timeFrameType = getSTOTimeFrameType(state);
  const simpleTimeFrame = getSTOSimpleTimeFrame(state);
  const earliestDateTime = getEarliestDateTime(state);
  const latestDateTime = getLatestDateTime(state);
  if (campaignSTOWasUsed) {
    return {
      send_time_optimization: {
        type: 'CAMPAIGN'
      }
    };
  }
  const isContactSTOUsed = publishingOption === NEW_PUBLISH_OPTIONS.CONTACT_STO;
  if (isContactSTOUsed) {
    if (timeFrameType === 'simple') {
      const timeRangeKey = useSnakeCase ? 'time_range' : 'timeRange';
      const withinOptimalHoursKey = useSnakeCase ? 'within_optimal_hours' : 'withinOptimalHours';
      return {
        send_time_optimization: {
          type: 'CONTACT',
          [timeRangeKey]: {
            [withinOptimalHoursKey]: simpleTimeFrame || 24
          }
        }
      };
    }
    if (timeFrameType === 'custom') {
      const timeRangeKey = useSnakeCase ? 'time_range' : 'timeRange';
      const earliestDateKey = useSnakeCase ? 'earliest_date' : 'earliestDate';
      const latestDateKey = useSnakeCase ? 'latest_date' : 'latestDate';
      return {
        send_time_optimization: {
          type: 'CONTACT',
          [timeRangeKey]: {
            [earliestDateKey]: earliestDateTime || 0,
            [latestDateKey]: latestDateTime || 0
          }
        }
      };
    }
  }
  return {
    send_time_optimization: null
  };
};

/**
 * Returns STO data in camelCase format for save operations
 */
export const getSTOSaveData = state => {
  return generateSTOData(state, false);
};

/**
 * Returns STO data in snake_case format for validation operations
 */
export const getSTOSaveDataValidation = state => {
  return generateSTOData(state, true);
};

/**
 * Combined selector that returns the appropriate publish date for both regular scheduling and Contact STO.
 * This fixes the issue where Contact STO with custom dates would show 12/31/1969 in the schedule confirmation modal.
 */
export const getEffectivePublishDate = createSelector([getContactSTOPublishDate, getPublishDate], (contactSTOPublishDate, regularPublishDate) => {
  // Use Contact STO publish date if available, otherwise use regular publish date
  return contactSTOPublishDate || regularPublishDate;
});
export const getEstimatedSendTime = createSelector([getNumToSendTo, getEmailThrottleSendSpeed], (numToSendTo, throttleSendSpeed) => {
  if (!throttleSendSpeed) {
    return null;
  }
  const estimatedSendTimeInMinutes = numToSendTo / throttleSendSpeed;
  if (estimatedSendTimeInMinutes < 1) {
    return null;
  }
  if (estimatedSendTimeInMinutes < 60) {
    return {
      timeUnit: SEND_TIME_UNIT.MINUTES,
      duration: Math.ceil(estimatedSendTimeInMinutes)
    };
  }
  const estimatedSendTimeInHours = estimatedSendTimeInMinutes / 60;
  return {
    timeUnit: SEND_TIME_UNIT.HOURS,
    duration: Math.ceil(estimatedSendTimeInHours)
  };
});